import { render } from "./BaseButton.vue?vue&type=template&id=b42cd8a6&scoped=true"
const script = {}

import "./BaseButton.vue?vue&type=style&index=0&id=b42cd8a6&lang=scss&scoped=true"

import exportComponent from "/Users/josiahsprankle/Desktop/personal/JDS-Music-Site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b42cd8a6"]])

export default __exports__